import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs, Button } from '@blueprintjs/core';
import CooccurrenceTab from './CooccurrenceTab.js';
import { Tooltip2, Classes } from '@blueprintjs/popover2';


class Cooccurrences extends React.PureComponent {

  state = {
    //selectedTabId: Object.keys(this.props.stats.byCorpus)[0],  // select first corpus by default
    selectedTabId:"Global",
    isCompareModalOpen:false,
    displayShortName:false
  }
  handleTabChange = (navbarTabId) => {
    if (navbarTabId !=="displayShortName") {
      this.setState({ selectedTabId: navbarTabId });
      //  this trick is to cope with the react-apex-chart show problem
      window.dispatchEvent(new Event('resize'));
    }
  }

  render() {
      const { cooc, coocSpec, t, estimatedResults, collocQuery, subCorpora } = this.props;
      var selectedTabId=this.state.selectedTabId;
      const tabs = [];

      const displayShortName=this.state.displayShortName;
      const plusOrMinus=displayShortName? "+":"-";
      const plusOrMinusTab=
          <Tab key="displayShortName" id="displayShortName" title={null} panel={null} >
            <Button small={true} onClick={()=>{this.setState({displayShortName:!this.state.displayShortName})}}>{plusOrMinus}</Button>
          </Tab>;
      tabs.push(plusOrMinusTab);

      // generate the global page, only when more than one page
      if (Object.keys(cooc).length > 2) {

        const coocTab = <CooccurrenceTab 
                            sessionId={this.props.sessionId} 
                            subCorpus={'_global_'} 
                            cooc={cooc['_global_']} 
                            coocSpec={coocSpec} 
                            displaySpec={false} 
                            collocQuery={collocQuery} 
                            estimatedResults={estimatedResults['_global_']}
                            performSearch={this.props.performSearch}
                            concordSampling={this.props.concordSampling}
                            csvDelimiter={this.props.csvDelimiter}
                            dispCriterion={this.props.dispCriterion}
                         />;
        const tab = <Tab key='Global' id='Global' title={t('global')} panel={coocTab} />;
        tabs.push(tab);
      }

      // generate the indidual stat pages (sub-corpus or partition)
      for (var i=0;i<subCorpora.length;i++) {
        const subCorpus=subCorpora[i];
        if (subCorpus!=='_global_' && cooc[subCorpus]) {
          const title=(displayShortName) ? (" "+(i+1).toString()).slice(-2):subCorpus;
          const coocTab = <CooccurrenceTab 
                              displayShortName={displayShortName}
                              sessionId={this.props.sessionId}  
                              subCorpus={subCorpus} 
                              cooc={cooc[subCorpus]} 
                              coocSpec={coocSpec} 
                              displaySpec={true} 
                              collocQuery={collocQuery} 
                              estimatedResults={estimatedResults[subCorpus]}
                              performSearch={this.props.performSearch}
                              concordSampling={this.props.concordSampling}
                              csvDelimiter={this.props.csvDelimiter}
                              dispCriterion={this.props.dispCriterion}

                          />;
            const tab = <Tab key={subCorpus} id={subCorpus} title={title} panel={coocTab} >
                          {displayShortName && <Tooltip2 content={subCorpus} className={Classes.TOOLTIP2_INDICATOR} placement="bottom" >…</Tooltip2>}
                        </Tab>;
            tabs.push(tab);
          if (Object.keys(cooc).length === 2) {
            selectedTabId=subCorpus;
          }
        }
      }

      return (
        <>
          <Tabs onChange={this.handleTabChange} selectedTabId={selectedTabId} renderActiveTabPanelOnly >
            {tabs}
          </Tabs>
        </>
      );
  }
}

Cooccurrences.propTypes = {
  subCorpora : PropTypes.array,
  // see prepCoocData for an example
  sessionId: PropTypes.string,
  cooc: PropTypes.object,
  coocSpec: PropTypes.object,
  collocQuery: PropTypes.object,
  estimatedResults: PropTypes.object,
  performSearch: PropTypes.func,
  concordSampling: PropTypes.bool,
  csvDelimiter:PropTypes.string,  
  dispCriterion:PropTypes.string
};

export default withTranslation()(Cooccurrences);
